export * from './base'

export const defaultToken = 'test_token'
export const defaultDomain = '.member.chukouplus.com'

export const env = 'test'
export const loginUrl = 'https://member.chukouplus.com/user/Index/login.html'
